import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="smooth-scroll"
export default class extends Controller {
  scroll(event) {
    event.preventDefault();
    const targetId = event.currentTarget.getAttribute("href").replace("#", "");
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      console.error("ターゲットが見つかりません:", targetId);
    }
  }
}
